import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axios';

export const fetchSubsidies = createAsyncThunk(
  'subsidies/fetchSubsidies',
  async () => {
    const response = await axiosInstance.get('/discounts/subsidies', {
      active: true,
    });
    return response.data;
  }
)

const subsidiesSlice = createSlice({
  name: 'subsidies',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubsidies.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSubsidies.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchSubsidies.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
})

export default subsidiesSlice.reducer;